import { useQueryClient } from '@tanstack/react-query'
import { LectureQuestionUpdateRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useQuestionsUpdate = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureQuestionUpdateRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: LectureQuestionUpdateRequest) => {
      try {
        const result = await mutation.mutateAsync({
          url: '/lectures/questions/update',
          data,
        })

        queryClient.invalidateQueries({ queryKey: ['questionsDetail'] })
        queryClient.invalidateQueries({ queryKey: ['lecture-list'] })

        return result
      } catch (error) {
        console.error('Question update failed:', error)
        throw error
      }
    },
  }
}
